export default __webpack_public_path__ + "static/media/ArrowRight.2e0179e7.svg";